import * as moment from 'moment';
import { EmployeesService } from "../../../services/index";
import { IEmployeeAvailability } from '../../../services/employeeAvailability.service';

class AvailabilityCalendarController implements ng.IComponentController {
    private availabilities: IEmployeeAvailability[];
    private uiConfig: any;
    private eventSources: any = [];
    private employeeId: string;
    
    constructor(
        private EmployeesService: EmployeesService,
        private $state: ng.ui.IStateService,
        private uiCalendarConfig: any,
        private $scope: ng.IScope,
        private $compile : ng.ICompileService,
        private $timeout : ng.ITimeoutService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        // console.log('init AvailabilityCalendarController')
        this.eventSources = [this.getEvents];
        // this.getEvents(moment().fromNow, '2016-07-13 23:00:00.0000000'.toDate(), null, function() {});

        this.uiConfig = {

            calendar: {

                height: 537,
                locale: 'nl',
                header: {
                    left: 'title',
                    right: ' prev,next month,agendaWeek,agendaDay'
                },
                buttonIcons: {
                    prev: ' fa fa-caret-left',
                    next: ' fa fa-caret-right',
                },
                displayEventEnd: true,

                axisFormat: 'h:mm',

                allDaySlot: false,
                timeFormat: 'H:mm',
                eventLimit: true,
                eventClick: this.openItem,
                //eventDrop: $scope.alertOnDrop,
                //eventResize: $scope.alertOnResize,
                eventRender: this.eventRender
            }

           
        };

       this.$timeout(() => {
          this.renderCalendar();
        });
    }


    private renderCalendar = () => {
        this.uiCalendarConfig.calendars['employeeCalendar'].fullCalendar('render');
        this.uiCalendarConfig.calendars['employeeCalendar'].fullCalendar('rerenderEvents');
    }

    private getEvents = (start, end, timezone, callback) => {
        // console.log('getEvents');
        // console.log(start);
        this.EmployeesService.customAll(this.employeeId + '/availabilityByRange', { 'start': start.toDate() , 'end': end.toDate() }).then((events: any) => {
            this.availabilities = events;
            // console.log(events);
            callback(events);
        });
    }

    private openItem = (event) => {
        this.$state.go('hr.employees.item.availability', { 'employeeId': this.employeeId, 'availabilityId': event.id });
    }

    private eventRender = (event, element, view) => {
        element.attr({
            'uib-tooltip': event.comment,
            'tooltip-append-to-body': true
        });
        //var employee = '';
        // if (event.shift.Employee) {
        //     var employee = '<br /><i>' + event.shift.Employee.DisplayName + '</i>';
        // }
        // element.append('<span>' + event.status.Name + employee + '</span>');
        if (!event.status) {
            event.status = "???";
        }

        var color: string;
        if (event.status.toLowerCase() == 'available') {
            color = '#2ECC71'; // @brand-success
        } else {
            color = '#d96557'; // @brand-danger
        }

        if (moment().isBefore(event.from)) {
            element.css({ 'background-color': color, 'border-color': color });
        } else {
            element.css({ 'background-color': color, 'border-color': color, 'opacity': 0.7 });
        }

        this.$compile(element)(this.$scope);
    }
}

export const availabilityCalendarComponent: ng.IComponentOptions = {
    controller: AvailabilityCalendarController,
    bindings: {
        employeeId : "<"
    },
    template: <string>require('./availability.calendar.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/hr/availability/availability.calendar.component.ts